module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"attendance":"Einlass"},"en":{"attendance":"Attendance"}}')
  delete Component.options._Ctor
}
